/* eslint-disable standard/no-callback-literal */
import 'isomorphic-fetch'

export class ImageManager {
  constructor () {
    this.allowedTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif']
    this.allowedThumbnailsExtensions = ['jpg']
    this.resizeQuality = 30
    this.resizeMimeType = 'image/jpeg'
  }

  loadImage = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => resolve(e.target.result)
    if (this.allowedTypes.includes(file.type)) {
      reader.readAsDataURL(file)
    } else {
      reject(new Error('Wrong type of file'))
    }
  })

  checkImageExistInUrl = (url, cb) => {
    const img = new Image()
    img.onload = () => cb({status: 'ok'})
    img.onerror = () => cb({status: 'error'})
    img.src = url
  }

  // eslint-disable-next-line no-undef
  loadImageFromUrl = url => fetch(url, {method: 'GET', cache: 'reload'}).then(response => {
    if (response.ok) {
      return response.blob()
    }
    throw new Error('load error')
  }).then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve({file: reader.result, type: blob.type, size: blob.size})
    reader.onerror = () => reject(new Error('load error'))
    reader.readAsDataURL(blob)
  }))

  rotateImage = (file, angle) => new Promise((resolve) => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const newImg = new Image()
    newImg.crossOrigin = 'Anonymous'
    newImg.onload = () => {
      canvas.width = newImg['height']
      canvas.height = newImg['width']
      context.save()
      context.translate(newImg.height / 2, newImg.width / 2)
      context.rotate(angle * Math.PI / 180)
      context.drawImage(newImg, -(newImg.width / 2), -(newImg.height / 2))
      context.restore()
      resolve(canvas.toDataURL())
    }
    newImg.src = file
  })

  rotateLeft = file => this.rotateImage(file, -90)
  rotateRight = file => this.rotateImage(file, 90)

  resizeImage = (file, maxSize) => new Promise(resolve => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const newImg = new Image()
    newImg.onload = () => {
      canvas.width = newImg.width
      canvas.height = newImg.height
      if (canvas.width > canvas.height) {
        if (canvas.width > maxSize.width) {
          canvas.height *= maxSize.width / canvas.width
          canvas.width = maxSize.width
        }
      } else {
        if (canvas.height > maxSize.height) {
          canvas.width *= maxSize.height / canvas.height
          canvas.height = maxSize.height
        }
      }
      context.save()
      context.drawImage(newImg, 0, 0, canvas.width, canvas.height)
      context.restore()
      resolve(canvas.toDataURL(this.resizeMimeType, this.resizeQuality))
    }
    newImg.src = file
  })

  createImage = url =>
    new Promise((resolve, reject) => {
      const image = new Image()
      image.addEventListener('load', () => resolve(image))
      image.addEventListener('error', error => reject(error))
      image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
      image.src = url
    })

  /**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 */
  getCroppedImg = async (imageSrc, pixelCrop, isBase64 = false) => {
    const image = await this.createImage(imageSrc)
    console.log('image width, height', image.width, image.height)
    const canvas = document.createElement('canvas')

    const sWidth = Math.round(image.width * (pixelCrop.width / 100))
    const sHeight = Math.round(sWidth * 0.75)

    canvas.width = sWidth
    canvas.height = sHeight

    const sX = pixelCrop.x !== 0 ? Math.round(image.width * (pixelCrop.x / 100)) : 0
    const sY = pixelCrop.y !== 0 ? Math.round(image.height * (pixelCrop.y / 100)) : 0
    const dX = 0
    const dY = 0

    const ctx = canvas.getContext('2d')

    if (!ctx) {
      return null
    }

    ctx.drawImage(
      image,
      sX,
      sY,
      sWidth,
      sHeight,
      dX,
      dY,
      sWidth,
      sHeight
    )
    // As Base64 string
    if (isBase64) return canvas.toDataURL('image/jpeg')

    // As a blob
    return new Promise((resolve, reject) => {
      canvas.toBlob(file => {
        console.log('file', file)
        resolve(URL.createObjectURL(file))
      }, 'image/jpeg')
    })
  }
}
